import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { TopicDTO } from '../../../services/api/api';
import { DiscussionService } from '../../../services/discussion.service';

@Component({
  selector: 'sb-topic-edit',
  templateUrl: './sb-topic-edit.component.html',
  styleUrls: ['./sb-topic-edit.component.scss'],
  standalone: false,
})
export class SbTopicEditComponent implements OnInit {
  @Output() topicEmitter: EventEmitter<number>;

  topicTitle: string;
  topicText: string;

  form = new UntypedFormGroup({
    TopicTheme: new UntypedFormControl('', [Validators.required]),
    TopicText: new UntypedFormControl('', [Validators.required]),
  });

  constructor(public discussionService: DiscussionService) {
    this.topicTitle = '';
    this.topicText = '';
    this.topicEmitter = new EventEmitter<number>();
  }

  get TopicTheme() {
    return this.form.get('TopicTheme');
  }

  get TopicText() {
    return this.form.get('TopicText');
  }

  ngOnInit(): void {
    this.onFormChanges();
  }

  onFormChanges(): void {
    this.form.valueChanges.subscribe(() => {
      this.discussionService.inputChanged = true;
    });
  }

  topicSubmission($event) {
    if ($event) {
      $event.stopPropagation();
    }
    this.topicText = this.TopicText.value;
    this.topicTitle = this.TopicTheme.value;
    if (
      0 < this.topicTitle.length &&
      this.topicTitle.length < 250 &&
      this.topicTitle.trim().length > 0 &&
      0 < this.topicText.length &&
      this.topicText.trim().length > 0
    ) {
      const post = new TopicDTO();
      // post.title = this.topicTitle;
      post.text = this.topicText;
      post.title = this.topicTitle;
      this.discussionService.createTopic(post).then(() => {
        const topicID = this.discussionService.createdTopicID;
        this.discussionService.createdTopicID = -1;
        this.topicEmitter.emit(topicID);
        this.discussionService.inputChanged = false;
      });
    }
  }

  cancelTopic($event) {
    if ($event) {
      $event.stopPropagation();
    }
    this.discussionService.newTopic = false;
    this.TopicTheme.setValue('');
    this.TopicText.setValue('');
    this.topicEmitter.emit(-1);
    this.discussionService.inputChanged = false;
  }
}
